module.exports = __webpack_public_path__ + "img/home-side.154db77d.png";